<div [formGroup]="parentForm">
	<div formGroupName="{{nestedFormGroupName}}">
		<label>{{(isUpperJaw ? 'Upper jaw' : 'Lower jaw') | translate}}</label>
		<div class="grid-layout" formGroupName="{{jawFormControlName}}">
			<div class="grid-row" formGroupName="{{MovementTypeFormGroupName.PROTRUDE_RETRUDE}}">
				<mat-radio-group formControlName="option">
					<mat-radio-button value="{{AnswerOption.PROTRUDE}}" (click)="onClick(AnswerOption.PROTRUDE, MovementTypeFormGroupName.PROTRUDE_RETRUDE)">{{ AnswerOption.PROTRUDE | translate}}</mat-radio-button>
					<mat-radio-button value="{{AnswerOption.RETRUDE}}" (click)="onClick(AnswerOption.RETRUDE, MovementTypeFormGroupName.PROTRUDE_RETRUDE)">{{ AnswerOption.RETRUDE | translate}}</mat-radio-button>
				</mat-radio-group>
				<div>
					<mat-form-field >
						<input matInput formControlName="text" data-cy="protrudeRetrudeText">
						<mat-error>{{"please fill in" | translate}}</mat-error>
						<mat-hint>{{"mm or other indication" | translate}}</mat-hint>
					</mat-form-field>
				</div>
			</div>
			<div class="grid-row" formGroupName="{{MovementTypeFormGroupName.PROCLINE_RECLINE}}">
				<mat-radio-group formControlName="option">
					<mat-radio-button value="{{AnswerOption.PROCLINE}}" (click)="onClick(AnswerOption.PROCLINE, MovementTypeFormGroupName.PROCLINE_RECLINE)">{{ AnswerOption.PROCLINE | translate}}</mat-radio-button>
					<mat-radio-button value="{{AnswerOption.RECLINE}}" (click)="onClick(AnswerOption.RECLINE, MovementTypeFormGroupName.PROCLINE_RECLINE)">{{ AnswerOption.RECLINE | translate}}</mat-radio-button>
				</mat-radio-group>
				<div>
					<mat-form-field>
						<input matInput formControlName="text">
						<mat-error>{{"please fill in" | translate}}</mat-error>
						<mat-hint>{{"mm or other indication" | translate}}</mat-hint>
					</mat-form-field>
				</div>
			</div>
			<div class="grid-row" formGroupName="{{MovementTypeFormGroupName.COMPRESS_EXPAND}}">
				<mat-radio-group formControlName="option">
					<mat-radio-button value="{{AnswerOption.COMPRESS}}" (click)="onClick(AnswerOption.COMPRESS, MovementTypeFormGroupName.COMPRESS_EXPAND)">{{ AnswerOption.COMPRESS | translate}}</mat-radio-button>
					<mat-radio-button value="{{AnswerOption.EXPAND}}" (click)="onClick(AnswerOption.EXPAND, MovementTypeFormGroupName.COMPRESS_EXPAND)">{{ AnswerOption.EXPAND | translate}}</mat-radio-button>
				</mat-radio-group>
				<div>
					<mat-form-field>
						<input matInput formControlName="text">
						<mat-error>{{"please fill in" | translate}}</mat-error>
						<mat-hint>{{"mm or other indication" | translate}}</mat-hint>
					</mat-form-field>
				</div>
			</div>
			<div class="grid-row" formGroupName="{{MovementTypeFormGroupName.TORQUE}}">
				<mat-radio-group formControlName="option">
					<mat-radio-button class="col-span-2" value="{{AnswerOption.TORQUE}}" (click)="onClick(AnswerOption.TORQUE, MovementTypeFormGroupName.TORQUE)">{{ "torque" | translate}}</mat-radio-button>
				</mat-radio-group>
				<div>
					<mat-form-field>
						<input matInput formControlName="text" data-cy="torqueText">
						<mat-error>{{"please fill in" | translate}}</mat-error>
						<mat-hint>{{ "teethAndDegrees" | translate}}</mat-hint>
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>
</div>
